import { Icon } from "@iconify/react";
import { AutoMode, Book, CorporateFare } from "@mui/icons-material";
import ScheduleSendIcon from '@mui/icons-material/ScheduleSend';
import connectimg from "../assets/imgs/favicon (3).png"; // Import the connect registration image
import axios from 'axios';
import { useState, useEffect } from "react";
import { BASE_URL } from "../services/configUrls";

// -----------------------------------------------------------------
const navConfig = [
  {
    title: "Dashboard",
    path: "/dashboard",
    icon: <Icon icon="mingcute:classify-2-fill" height={22} width={22} />,
  },

  {
    title: "Academy Program",
    path: "/academy-program",
    icon: <Icon icon="mdi:google-classroom" height={22} width={22} />,
  },

  // Admin....................................

  {
    title: "Institute",
    path: "/institute",
    icon: <Icon icon="fa:university" height={22} width={22} />,
  },
  {
    title: "Awards",
    path: "/award-management",
    icon: <Icon icon="gg:awards" height={22} width={22} />,
  },
  {
    title: "Academy",
    path: "/academy",
    icon: <Icon icon="ic:round-corporate-fare" height={22} width={22} />,
  },
  {
    title: "Educators",
    path: "/admin-educator",
    icon: <Icon icon="ph:chalkboard-teacher-bold" height={22} width={22} />,
  },
  {
    title: "Magazines",
    path: "/admin/magazines",
    icon: <Icon icon="solar:book-bookmark-bold-duotone" height={22} width={22} />,
    allowedRoles: ["admin"],
  },
  //

  {
    title: "Student",
    path: "/add-student",
    icon: <Icon icon="mdi:account-plus" height={22} width={22} />,
    allowedRoles: ["leaders", "dspoc"],
  },

  {
    title: "Student",
    path: "/admin-student-report",
    icon: <Icon icon="hugeicons:students" height={22} width={22} />,
    allowedRoles: ["admin"],
  },
  {
    title: "Student",
    path: "/corporate-student-report",
    icon: <Icon icon="hugeicons:students" height={22} width={22} />,
    allowedRoles: ["corporate"],
  },
  {
    title: "Manage User",
    path: "/manage-user",
    icon: <Icon icon="mdi:account-group" height={22} width={22} />,
    children: [
      {
        title: "Student",
        path: "/add-student",
        parent: "Manage User",
        icon: <Icon icon="mdi:account-plus" height={22} width={22} />,
      },
      {
        title: "Staff",
        path: "/membership-list",
        parent: "Manage User",
        icon: (
          <Icon icon="icon-park-outline:file-staff" height={22} width={22} />
        ),
      },
    ],
  },
  {
    title: "Institutes",
    path: "/institutes",
    icon: <Icon icon="fa:university" height={22} width={22} />,
    children: [
      {
        title: "Institute Dashboard",
        path: "/total-staff",
        parent: "Institutes",
        icon: <Icon icon="mingcute:classify-2-fill" height={22} width={22} />,
      },
      {
        title: "Student",
        path: "/student-staff",
        parent: "Institutes",
        icon: <Icon icon="mdi:account-school" height={22} width={22} />, // student icon
      },
      {
        title: "Internship",
        path: "/internship-all-staff",
        parent: "Institutes",
        icon: <Icon icon="vaadin:academy-cap" height={22} width={22} />,
      },
      {
        title: "Institute Summary",
        path: "/institute-summary-staff",
        parent: "Institutes",
        icon: <Icon icon="tabler:table" height={22} width={22} />,
      },
      {
        title: "Leaders & Faculty",
        path: "/leaders-spocs-faculty",
        parent: "Institutes",
        icon: <Icon icon="mdi:account-tie-voice" height={22} width={22} />,
      },
    ],
  },
  {
    title: "Internship",
    path: "/main-sidebar",
    icon: <Icon icon="mdi:account-graduation-outline" height={25} width={25} />,
  },
  {
    title: "Connect Registrations",
    path: "/connect-reg",
    icon: <img src={connectimg} alt="Connect" height={22} width={22} />,
  },
  {
    title: "Talent Connect",
    path: "/coming-soon",
    icon: <Icon icon="tabler:users-group" height={22} width={22} />,
  },
  // {
  //   title: "Create Activities",
  //   path: "/create-features",
  //   icon: <Icon icon="pepicons-pop:cv" height={22} width={22} />,
  // },
  // {
  //   title: "Create Membership",
  //   path: "/create-membership",
  //   icon: <Icon icon="pepicons-pop:cv" height={22} width={22} />,
  // },
  // {
  //   title: "Create Institute",
  //   path: "/institute-creation",
  //   icon: <Icon icon="pepicons-pop:cv" height={22} width={22} />,
  // },
  // {
  //   title: "Add Subscription",
  //   path: "/institute-registration",
  //   icon: <Icon icon="pepicons-pop:cv" height={22} width={22} />,
  // },
  // {
  //   title: "Tech Camp",
  //   path: "/acalendar",
  //   // parent: "Activities",
  //   icon: <Icon icon="carbon:user-activity" height={22} width={22} />,
  //   badge: "Testing", // Added testing badge
  // },

  {
    title: "Events",
    path: "/multi",
    icon: <Icon icon="ic:round-event" height={22} width={22} />,
    children: [
      {
        title: "Connect",
        path: "/multi",
        parent: "Events",
        icon: <img src={connectimg} alt="Connect" height={22} width={22} />,
      },
    ],
  },

  {
    title: "Activities",
    path: "/tech-camp-calendar",
    icon: (
      <Icon
        icon="material-symbols-light:browse-activity-rounded"
        height={22}
        width={22}
      />
    ),
  },

  // {
  //   title: "My Calendar",
  //   path: "/mcalendar",
  //   icon: <Icon icon="ic:round-event" height={22} width={22} />,
  //   // badge: "Testing", // Added testing badge
  // },

  {
    title: "Activity",
    path: "/multi",
    icon: <Icon icon="ic:round-event" height={22} width={22} />,
    allowedRoles: ["admin", "staff", "trainerspoc", "leaders", "trainer", "spoc", "educator", "accounts", "support", "dspoc"],
    children: [
      // {
      //   title: "My Calendar",
      //   path: "/mcalendar",
      //   parent: "Activity",
      //   icon: <Icon icon="ic:round-event" height={22} width={22} />,
      //   // badge: "Testing", // Added testing badge
      // },
      {
        title: "My Activities",
        path: "/techcamp-event",
        parent: "Activity",
        icon: <Icon icon="carbon:event" height={22} width={22} />,
        allowedRoles: ["trainer"],
      },
      {
        title: "My FDP Interests",
        path: "/my-fdp-interests",
        parent: "Activity",
        icon: <Icon icon="carbon:education" height={22} width={22} />,
        allowedRoles: ["trainer"],
      },
      {
        title: "Activity History",
        path: "/event_history",
        parent: "Activity",
        icon: <Icon icon="material-symbols:history" height={22} width={22} />,
        allowedRoles: ["staff", "trainerspoc", "spoc", "trainer", "educator", "accounts", "support", "dspoc", "leaders"],
      },
      // {
      //   title: "FDP",
      //   path: "/fdp-event",
      //   parent: "Activity",
      //   icon: (
      //     <Icon
      //       icon="material-symbols:event-seat-sharp"
      //       height={22}
      //       width={22}
      //     />
      //   ),
      //   // badge: "Testing", // Added testing badge
      // },
      // {
      //   title: "EDP",
      //   path: "/edp-event",
      //   parent: "Activity",
      //   icon: (
      //     <Icon
      //       icon="majesticons:hand-pointer-event-line"
      //       height={22}
      //       width={22}
      //     />
      //   ),
      //   // badge: "Testing", // Added testing badge
      // },
    ],
  },
  {
    title: "Event",
    path: "/agenda-manage",
    icon: <Icon icon="ic:round-event" height={22} width={22} />,
    allowedRoles: ["admin", "staff", "trainerspoc", "leaders", "trainer", "spoc", "educator", "accounts", "support", "dspoc"],
    children: [
      // trainer availability and event types
      {
        title: "Connect",
        path: "/multi",
        parent: "Event",
        icon: <img src={connectimg} alt="Connect" height={22} width={22} />,
        allowedRoles: ["staff", "leaders"],
      },
      {
        title: "Dashboard",
        path: "/acalendar",
        parent: "Event",
        icon: <Icon icon="ic:round-event" height={22} width={22} />,
        allowedRoles: ["admin", "staff", "trainerspoc"],
      },
      {
        title: "Tech Camp",
        path: "/techcamp_dashboard",
        parent: "Event",
        icon: <Icon icon="ic:round-event" height={22} width={22} />,
        allowedRoles: ["admin", "staff", "trainerspoc"],
      },
      {
        title: "FDP",
        path: "/fdp_dashboard",
        parent: "Event",
        icon: <Icon icon="ic:round-event" height={22} width={22} />,
        allowedRoles: ["admin", "staff", "trainerspoc"],
      },
      // {
      //   title: "Prerequisites Documents",
      //   path: "/spoc-prerequisites",
      //   parent: "Event",
      //   icon: <Icon icon="material-symbols:folder-open-rounded" height={22} width={22} />,
      //   allowedRoles: ["admin", "staff", "trainerspoc"],
      // },
      // {
      //   title: "EDP",
      //   path: "/edp_dashboard",
      //   parent: "Event",
      //   icon: <Icon icon="ic:round-event" height={22} width={22} />,
      //   allowedRoles: ["admin", "staff", "trainerspoc"],
      // },
      {
        title: "Career Talk",
        path: "/careertalk_staff",
        icon: <Icon icon="mdi:account-tie" height={22} width={22} />,
        allowedRoles: ["staff", "admin"]
      },
      {
        title: "Activity History",
        path: "/event_history",
        parent: "Event",
        icon: <Icon icon="material-symbols:history" height={22} width={22} />,
        allowedRoles: ["admin"],
      },

      // {
      //   title: "Connect",
      //   path: "/event-connect",
      //   parent: "Event",
      //   icon: <img src={connectimg} alt="Connect" height={22} width={22} />,
      // },
      // {
      //   title: "Connect Agenda",
      //   path: "/agenda-manage",
      //   parent: "Event",
      //   icon: <img src={connectimg} alt="Connect" height={22} width={22} />,
      // },
      // {
      //   title: "Connect Registrations",
      //   path: "/connect-reg",
      //   parent: "Event",
      //   icon: <img src={connectimg} alt="Connect" height={22} width={22} />,
      // },
      // {
      //   title: "Activities Calendar",
      //   path: "/acalendar",
      //   parent: "Event",
      //   icon: <Icon icon="ic:round-event" height={22} width={22} />,
      //   badge: "Testing", // Added testing badge
      // },
    ],
  },
  {
    title: "Event",
    path: "/event",
    icon: <Icon icon="ic:round-event" height={22} width={22} />,
    allowedRoles: ["tpo"],
  },
  {
    title: "Faculty Events",
    path: "/faculty-events",
    icon: <Icon icon="solar:calendar-broken" height={25} width={25} />,
  },
  {
    title: "Domain Prerequisites Editor",
    path: "/trainer-document-editor",
    icon: <Icon icon="solar:document-add-bold-duotone" height={24} width={24} />,
    allowedRoles: ["trainerspoc", "trainer", "spoc", "admin"],
  },
  {
    title: "Industry COE",
    path: "/coe",
    icon: <Icon icon="solar:documents-broken" height={25} width={25} />,
  },
  {
    title: "COE",
    path: "/admin-coe",
    icon: <Icon icon="solar:documents-broken" height={25} width={25} />,
  },
  {
    title: "Subscription",
    path: "/sub-details",
    icon: <Icon icon="mdi:credit-card-outline" height={22} width={22} />,
  },
  {
    //pratyukticode three lines
    title: "Domain Assign",
    path: "/programassign",
    icon: <Icon icon="mdi:credit-card-outline" height={22} width={22} />,
  },
  //............................................



  {
    title: "News & Events",
    path: "/news-events",
    icon: (
      <Icon icon="material-symbols:event-note-rounded" height={22} width={22} />
    ),
  },
  {
    title: "Publication",
    path: "/publication",
    icon: <Book />,
  },

  {
    title: "Resume",
    path: "/resume",
    icon: <Icon icon="pepicons-pop:cv" height={22} width={22} />,
  },
  {
    title: "Create Features",
    path: "/create-features",
    icon: <Icon icon="pepicons-pop:cv" height={22} width={22} />,
  },
  {
    title: "Create Membership",
    path: "/create-membership",
    icon: <Icon icon="pepicons-pop:cv" height={22} width={22} />,
  },
  {
    title: "Create Institute",
    path: "/institute-creation",
    icon: <Icon icon="pepicons-pop:cv" height={22} width={22} />,
  },
  {
    title: "Onboarding Institute",
    path: "/institute-registration",
    icon: <Icon icon="pepicons-pop:cv" height={22} width={22} />,
  },
  // {
  //   title: "Staff",
  //   path: "/staff",
  //   icon: <Icon icon="clarity:employee-solid" height={22} width={22} />,
  // },
  {
    title: "Staff",
    path: "/staff",
    icon: <Icon icon="clarity:employee-solid" height={22} width={22} />,
    parent: "Staff",
    children: [
      {
        title: "RM",
        path: "/staff",
        icon: <Icon icon="clarity:employee-solid" height={22} width={22} />,
      },
      {
        title: "Trainer",
        path: "/trainer-management",
        icon: <Icon icon="mdi:account-tie" height={22} width={22} />,
      },
    ],
  },
  {
    title: "Schedule Email",
    path: "/schedule_email",
    icon: <ScheduleSendIcon />,
  },
  {
    title: "Placement",
    path: "/placement",
    icon: <Icon icon="ic:twotone-work" height={22} width={22} />,
    parent: "Placement",
    children: [
      {
        title: "Resume",
        path: "/placement",
        icon: <CorporateFare />,
      },
      {
        title: "Job Details",
        path: "/placement",
        icon: <CorporateFare />,
      },
      {
        title: "Interview",
        path: "/placement",
        icon: <CorporateFare />,
      },
    ],
  },
  {
    title: "Support",
    path: "/support",
    icon: (
      <Icon icon="fluent:person-support-20-filled" height={22} width={22} />
    ),
  },
  {
    title: "Report",
    // path: "/report",
    icon: <Icon icon="mdi:report-box" height={22} width={22} />,
    children: [
      {
        title: "Student",
        path: "/payment",
        icon: <CorporateFare />,
      },
      {
        title: "Resume",
        path: "/report",
        icon: <CorporateFare />,
      },
    ],
  },

  {
    title: "Tickets",
    path: "/get token",
    icon: <Icon icon="material-symbols:token-rounded" height={22} width={22} />,
    parent: "Tickets",
    children: [
      {
        title: "All Tickets",
        path: "/getticket",
        icon: <CorporateFare />,
      },
      {
        title: "My Tickets",
        path: "/token",
        icon: <CorporateFare />,
      },
      {
        title: "History",
        path: "/history",
        icon: <Icon icon="material-symbols:history" height={22} width={22} />,
      },
    ],
  },
  {
    title: "Institute Tickets",
    path: "/staff-ticket",
    icon: <Icon icon="material-symbols:token-rounded" height={22} width={22} />,
    parent: "Institute Tickets",

    children: [
      {
        title: "My Tickets",
        path: "/staff-ticket",
        icon: <CorporateFare />,
      },
      {
        title: "History",
        path: "/staff-ticket-history",
        icon: <Icon icon="material-symbols:history" height={22} width={22} />,
      },
    ],
  },
  {
    title: "Chatbot",
    path: "/adminchatbot",
    icon: <Icon icon="material-symbols:token-rounded" height={22} width={22} />,
    parent: "Chatbot",

    children: [
      {
        title: "Institute chatbot",
        path: "/adminchatbot",
        icon: <CorporateFare />,
      },
      {
        title: "Student Chatbot",
        path: "/studentchatbot",
        icon: <Icon icon="material-symbols:history" height={22} width={22} />,
      },
    ],
  },

  {
    title: "Institutes Tickets",
    path: "/institute ticket",
    icon: <Icon icon="material-symbols:token-rounded" height={22} width={22} />,
    parent: "Institute Tickets",

    children: [
      {
        title: "Institutes Tickets",
        path: "/institute ticket",
        icon: <CorporateFare />,
      },
      {
        title: "My Assign Ticket ",
        path: "/assignticket",
        icon: <Icon icon="material-symbols:token-rounded" height={22} width={22} />
      }
    ],
  },

  {
    title: "IT Support",
    path: "/Itsupport",
    icon: (
      <Icon icon="fluent:person-support-20-filled" height={22} width={22} />
    ),
    parent: "IT Support",
    children: [
      {
        title: "Support Dashboard",
        path: "/supportdashboard",
        icon: <Icon icon="mdi:report-box" height={22} width={22} />,
      },
      {
        title: "Support Staff",
        path: "/support staff",
        icon: (
          <Icon icon="fluent:person-support-20-filled" height={22} width={22} />
        ),
      },
    ],
  },
  // Talaent Connect..................
  {
    title: "Company",
    path: "/company",
    icon: (
      <Icon
        icon="material-symbols:corporate-fare-rounded"
        height={22}
        width={22}
      />
    ),
  },

  {
    title: "Job Description",
    path: "/job-description",
    icon: <Icon icon="carbon:batch-job" height={22} width={22} />,
  },
  {
    title: "Job Post",
    path: "/job-post",
    icon: <Icon icon="material-symbols:post-outline" height={22} width={22} />,
  },
  {
    title: "Activities Calendar",
    path: "/acalendar",
    icon: <Icon icon="ic:round-event" height={22} width={22} />,
  },
  // {
  //   title: "Certificates",
  //   path: "/educator-event",
  //   icon: <Icon icon="ic:round-event" height={22} width={22} />,
  // },

  {
    title: "Job Applications",
    path: "/applications",
    icon: <Icon icon="pepicons-print:cv" height={22} width={22} />,
  },
  {
    title: "Settings",
    path: "/settings",
    icon: <Icon icon="material-symbols:settings" height={22} width={22} />,
  },
  // {
  //   title: "MOU",
  //   path: "/sub-details",
  //   icon: <Icon icon="uil:notebooks" height={22} width={22} />,
  // },
  {
    title: "Process Document",
    path: "/Domain",
    icon: <Icon icon="material-symbols:token-rounded" height={22} width={22} />,
    parent: "Process Document",
    children: [
      {
        title: "Process Document",
        path: "/Domain",
        icon: (
          <Icon icon="material-symbols:token-rounded" height={22} width={22} />
        ),
      },
      {
        title: "Showcase certificate",
        path: "/file-manage",
        icon: <Icon icon="material-symbols:token-rounded" />,
      },
    ],
  },
  {
    title: "Products",
    path: "/support/products",
    icon: <Icon icon="mdi:package-variant-closed" height={22} width={22} />,
  },

  {
    title: "Students",
    path: "/get-student",
    icon: <Icon icon="hugeicons:students" height={22} width={22} />,
  },
  {
    title: "Bookings",
    path: "/designer/upcoming-events",
    icon: <Icon icon="mdi:calendar-multiselect" height={22} width={22} />,
    parent: "Bookings",
    children: [
      {
        title: "Banner Upload",
        path: "/designer/upcoming-events",
        parent: "Bookings",
        icon: <Icon icon="mdi:calendar-clock" height={20} width={20} />,
      },
      {
        title: "Social Poster",
        path: "/designer/past-events",
        parent: "Bookings",
        icon: <Icon icon="mdi:calendar-check" height={20} width={20} />,
      },
    ],
  },
  {
    title: "Rising star",
    path: "/risingstar",
    icon: <Icon icon="material-symbols:token-rounded" height={22} width={22} />,
  },
  {
    title: "Trainers",
    path: "/manage-trainers",
    icon: <Icon icon="mdi:account-group" height={22} width={22} />,
  },
  {
    title: "Global programs",
    path: "/globalprogram",
    icon: <Icon icon="material-symbols:token-rounded" height={22} width={22} />
  },

  {
    title: "Announcement",
    path: "/Itsupport",
    icon: (
      <Icon icon="fluent:person-support-20-filled" height={22} width={22} />
    ),
    parent: "Announcement",
    children: [
      {
        title: "Popup  Editor",
        path: "/announcement",
        icon: <Icon icon="mdi:report-box" height={22} width={22} />,
      },
      {
        title: "Popup Preview",
        path: "/preview",
        icon: (
          <Icon icon="fluent:person-support-20-filled" height={22} width={22} />
        ),
      },
      {
        title: "Login Announcement",
        path: "/announcement-login",
        icon: <Icon icon="mdi:announcement" height={22} width={22} />,
      },
      {
        title: "Student banner",
        path: "/advrtise",
        icon: <Icon icon="mdi:announcement" height={22} width={22} />,
      },
    ],
  },
  {
    title: "Role Access",
    path: "/spoc-role-access",
    icon: <Icon icon="mdi:shield-account-outline" height={22} width={22} />,
  },
  {
    title: "Achievement",
    path: "/achievement",
    icon: <Icon icon="lucide:trophy" height={22} width={22} />,
    badge: "New",
  },
 {
  title: "Guide Book",
  path: "/guide-book",
  icon: <Icon icon="lucide:book-open" height={22} width={22} />,
  badge: "New",
},
];

const roleTitles = {
  corporate: [
    "Dashboard",
    "Student",
  ],
  spoc: [
    "Dashboard",
    "Internship",
    // "Event/Activity",
    "Activities",
    "Events",
    "Jobs",
    "Student Info",
    "Corporate",
    "Educator",
    "Manage User",
    // "Activity",
    "Talent Connect",
    "Subscription",
    "Internship Testing",
    // "Reports",

    // "Awards & Recognition",
    // "News & Events",
    // "Talent Connect",
    // "Publication",
    "Membership",
    "Certificate",
    "Institutional Details",
    "MOU",
    "Industry COE",
    "Role Access",
    "Achievement"

    // "Support",
  ],
  management: [
    "Dashboard",
    "Internship",
    "Educator",
    "Corporate",
    "Membership",
  ],
  educator: ["Dashboard","Internship", "Educator", "MOU", "Industry COE", "Faculty Events"],

  leaders: [
    "Dashboard",
    "Internship",
    "Student",
    "Talent Connect",
    "Event",
    "Event/Activity",
    "Subscription",
    "COE",
    "MOU",
    "Industry COE",
  ],
  dspoc: [
    "Dashboard",
    "Internship",
    "Activities",
    "Student",
    "Talent Connect",
    "Event/Activity",
    "Subscription",
    "COE",
    "MOU",
    "Industry COE",
  ],
  tpo: [
    "Dashboard",
    "Event",
  ],
  trainer: [
    "Dashboard",
    "My Calendar",
    "Activity",

    // "Internship",
    // "Student",
    // "Talent Connect",
    // "Event/Activity",
    // "Subscription",
    // "COE",
  ],
  manager: [
    "Dashboard",
    "Internship",
    "College List",
    "Academy Program",
    "Institutional Details",
    "Academy",
  ],
  accounts: [
    "Dashboard",
    "Create Membership",
    "Create Institute",
    "Add Subscription",
    "Create Activities",
    // "Create Invoice",
  ],
  account_manager: [
    "Dashboard",
    "Internship",
    "College List",
    "Academy Program",
    "Institutional Details",
  ],
  talent: [
    "Dashboard",
    "Company",
    "Job Description",
    "Job Post",
    "Job Applications",
    // "Placement",
    // "Resume",
    // "Report",
    // "Support"
  ],
  admin: [
    "Dashboard",
    "Event",
    "IT Support",
    "Trainer",
    // "Internship",
    "Institute",
    // "Academy Program",
    // "Institutional Details",
    "Educators",
    "Student",
    "Academy",
    "Awards",
    "Staff",
    "Schedule Email",
    "Domain Assign", //pratyukticode
    // "Educator",
    // "Settings",
    "Announcement",
    "Login Announcement",
    "COE",
    "Magazines",
  ],
  support: ["Dashboard", "History", "Tickets", "Process Document", "Students", "Institutes Tickets", "Chatbot", "Products","Guide Book"],
  accounts: [
    "Dashboard",
    "Create Membership",
    "Create Institute",
    "Onboarding Institute",
    "Create Features",
  ],
  staff: [
    "Dashboard",
    "Institutes",
    "Connect Registrations",
    // "Internship",
    "Event Details",
    "Tech Camp",
    "Event",
    "Institute Tickets",
    "Career Talk",
    "Global programs",
    "Leaders & Faculty"
    // "Institute",
    // "Academy Program",
    // "Institutional Details",
    //  "Educator",

    // "Academy",
  ],
  trainerspoc: [
    "Dashboard",
    "Trainers",
    "Event"
  ],
  desiner: [
    "Dashboard",
    "Bookings",
    "Banner Upload",
    "Social Banner",
    "Rising star"
  ],
  business_development_manager: [
    "Dashboard"
  ],
};



// Roles that use dynamic SPOC-configured access
const DYNAMIC_ROLES = ['dspoc', 'leaders', 'educator', 'tpo', 'trainer'];

const filterNavConfig = (roles, userId = null) => {
  const allowedTitles = [];
  const activeRoles = Object.keys(roles).filter(r => roles[r]);

  // 1. Populate allowedTitles based on active roles for default access
  for (const role in roles) {
    if (roles[role] && roleTitles[role]) {
      allowedTitles.push(...(roleTitles[role] || []));
    }
  }

  // Dynamic history access check: Admin sees under "Event", other roles see under "Activity"
  let hasEventHistoryAccess = false;
  if (activeRoles.includes("admin")) {
    hasEventHistoryAccess = true;
  } else {
    try {
      const myPermsRaw = localStorage.getItem("my_event_history_permissions");
      if (myPermsRaw) {
        const myPerms = JSON.parse(myPermsRaw);
        hasEventHistoryAccess = Boolean(myPerms?.is_admin || myPerms?.can_view_event_history || myPerms?.has_fdp_history || myPerms?.has_techcamp_history);
      } else {
        const saved = localStorage.getItem("history_role_access_config");
        if (saved) {
          const perms = JSON.parse(saved);
          hasEventHistoryAccess = activeRoles.some(role => {
            const r = role.toLowerCase();
            return Boolean(
              perms[r]?.has_fdp_history === true ||
              perms[r]?.has_techcamp_history === true ||
              perms[r]?.has_fdp_history === "1" ||
              perms[r]?.has_techcamp_history === "1"
            );
          });
        }
      }
    } catch (e) {
      console.error(e);
    }
  }

  if (hasEventHistoryAccess) {
    if (activeRoles.includes("admin")) {
      if (!allowedTitles.includes("Event")) allowedTitles.push("Event");
    } else {
      if (!allowedTitles.includes("Activity")) allowedTitles.push("Activity");
    }
  }

  // 2. Check if SPOC has configured EXTRA dynamic access for this user
  const DYNAMIC_ROLES = ['dspoc', 'leaders', 'educator', 'tpo', 'trainer'];
  const isDynamicRole = activeRoles.some(r => DYNAMIC_ROLES.includes(r));
  const rawPaths = localStorage.getItem('spocAllowedPaths');
  const dynamicAllowedPaths = (isDynamicRole && rawPaths) ? JSON.parse(rawPaths) : [];

  return navConfig
    .filter(item => {
      if (item.title === "Guide Book") {
        return activeRoles.includes("support");
      }

      // Is it allowed by default roleTitles?
      let isBaseAllowed = false;
      if (item.allowedRoles) {
        isBaseAllowed = item.allowedRoles.some(role => activeRoles.includes(role)) && allowedTitles.includes(item.title);
      } else {
        isBaseAllowed = allowedTitles.includes(item.title);
      }

      // Is it allowed by extra dynamic SPOC access?
      let isDynamicAllowed = false;
      if (isDynamicRole && dynamicAllowedPaths && dynamicAllowedPaths.length > 0) {
        if (item.path === '/dashboard') isDynamicAllowed = true;
        else if (item.path) isDynamicAllowed = dynamicAllowedPaths.includes(item.path);
      }

      // Special handling for Achievement
      if (item.title === "Achievement") {
        const isEligible = localStorage.getItem('achievementEligible') === 'true';
        if (!isEligible) {
          return false;
        }
      }

      return isBaseAllowed || isDynamicAllowed;
    })
    .map(item => {
      let children = item.children;
      if (children) {
        children = children.filter(child => {
          // Dynamic check for Event History:
          if (child.path === "/event_history") {
            // For Event menu: Only show for Admin
            if (child.parent === "Event") {
              return activeRoles.includes("admin");
            }
            // For Activity menu: Only show for non-Admin roles with granted permissions
            if (child.parent === "Activity") {
              if (activeRoles.includes("admin")) return false;
              try {
                const myPermsRaw = localStorage.getItem("my_event_history_permissions");
                if (myPermsRaw) {
                  const myPerms = JSON.parse(myPermsRaw);
                  return Boolean(myPerms?.can_view_event_history || myPerms?.has_fdp_history || myPerms?.has_techcamp_history);
                }

                const saved = localStorage.getItem("history_role_access_config");
                if (saved) {
                  const perms = JSON.parse(saved);
                  return activeRoles.some(role => {
                    const r = role.toLowerCase();
                    return Boolean(
                      perms[r]?.has_fdp_history === true ||
                      perms[r]?.has_techcamp_history === true ||
                      perms[r]?.has_fdp_history === "1" ||
                      perms[r]?.has_techcamp_history === "1"
                    );
                  });
                }
              } catch (e) {
                console.error(e);
              }
              return false; // Hidden by default until access is assigned
            }
          }

          // Is child allowed by default?
          let isChildBaseAllowed = true;
          if (child.allowedRoles) {
            isChildBaseAllowed = child.allowedRoles.some(role => activeRoles.includes(role));
          }

          // Is child allowed by dynamic SPOC access?
          let isChildDynamicAllowed = false;
          if (isDynamicRole && dynamicAllowedPaths && dynamicAllowedPaths.length > 0 && child.path) {
            isChildDynamicAllowed = child.path === '/dashboard' || dynamicAllowedPaths.includes(child.path);
          }

          return isChildBaseAllowed || isChildDynamicAllowed;
        })
        .map(child => {
          if (child.path === "/acalendar" && child.parent === "Event") {
            return {
              ...child,
              title: activeRoles.includes("trainerspoc") ? "Bookings" : "Dashboard"
            };
          }
          return child;
        });
      }
      return { ...item, children };
    })
    .filter(item => !item.children || item.children.length > 0);
};
export const useUserAuth = () => {
  const [userId, setUserId] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  // Helper: fetch SPOC-configured allowed paths and cache them
  const fetchSpocAllowedPaths = async (accessToken) => {
    try {
      const activeRole = localStorage.getItem("Authorise") || "";
      const res = await axios.get(`${BASE_URL}/spoc-access/my-access?role=${activeRole}`, {
        headers: { Authorization: `Bearer ${accessToken}` }
      });
      if (res.data?.dynamic && res.data?.allowed_paths) {
        const combinedPaths = [...new Set([...(res.data.allowed_paths || []), ...(res.data.default_paths || [])])];
        localStorage.setItem('spocAllowedPaths', JSON.stringify(combinedPaths));
        console.log('✅ Loaded dynamic SPOC access paths:', combinedPaths);
      } else {
        // No dynamic config — clear any stale data
        localStorage.removeItem('spocAllowedPaths');
      }

      // Check achievement/awards eligibility
      try {
        const awardsRes = await axios.get(`${BASE_URL}/awards/show_upload`, {
          headers: { Authorization: `Bearer ${accessToken}` }
        });
        if (awardsRes.data && awardsRes.data.is_eligible) {
          localStorage.setItem('achievementEligible', 'true');
        } else {
          localStorage.setItem('achievementEligible', 'false');
        }
      } catch (err) {
        console.error("Error fetching milestone eligibility:", err);
        localStorage.setItem('achievementEligible', 'false');
      }
    } catch (err) {
      // Not a SPOC-managed role, or error — remove stale paths
      localStorage.removeItem('spocAllowedPaths');
      localStorage.setItem('achievementEligible', 'false');
    }
  };

  useEffect(() => {
    const fetchUserIdFromAPI = async () => {
      try {
        const urlParams = new URLSearchParams(window.location.search);
        const accessToken = urlParams.get("accessToken");
        const refreshToken = urlParams.get("refreshToken");
        const email = urlParams.get("email");

        let finalAccessToken = accessToken;

        // If URL has tokens → parse them via backend API
        if (accessToken && refreshToken && email) {
          console.log("🔄 Parsing tokens from redirect URL...");

          const data = {
            redirect_url: `${window.location.origin}?accessToken=${accessToken}&refreshToken=${refreshToken}&email=${email}`,
          };

          const accessTokenFromStorage = localStorage.getItem("accessToken");

          const response = await axios.post(
            `${BASE_URL}/staffmetting/fetch_token`,
            data,
            {
              headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${accessTokenFromStorage}`
              }
            }
          );

          if (response.data?.user_id) {
            console.log("✅ User ID received from API:", response.data.user_id);
            const userIdValue = Number(response.data.user_id); // Convert to number
            setUserId(userIdValue);
            localStorage.setItem("userId", String(userIdValue)); // Store as string

            localStorage.setItem("accessToken", accessToken);
            localStorage.setItem("refreshToken", refreshToken);
            localStorage.setItem("userEmail", email);

            const newUrl =
              window.location.protocol +
              "//" +
              window.location.host +
              window.location.pathname;
            window.history.replaceState({}, document.title, newUrl);
            // Fetch SPOC-configured paths for this user
            await fetchSpocAllowedPaths(accessToken);
            setIsLoading(false);
            return;
          }
        }

        // Check if userId is already in localStorage
        const storedUserId = localStorage.getItem("userId");
        console.log("📦 Stored userId from localStorage:", storedUserId);

        if (storedUserId && storedUserId !== "null" && storedUserId !== "undefined") {
          const parsedUserId = parseInt(storedUserId, 10);
          if (!isNaN(parsedUserId)) {
            console.log("✅ User ID found in localStorage:", parsedUserId);
            setUserId(parsedUserId);
            // Fetch SPOC paths on every page load using stored token
            const storedToken = localStorage.getItem("accessToken");
            if (storedToken) await fetchSpocAllowedPaths(storedToken);
            setIsLoading(false);
            return;
          } else {
            console.warn("⚠️ Invalid userId in localStorage:", storedUserId);
            localStorage.removeItem("userId"); // Clean up invalid value
          }
        }

        // If no tokens in URL, try localStorage
        if (!finalAccessToken) {
          finalAccessToken = localStorage.getItem("accessToken");
        }

        // If still no token, abort
        if (!finalAccessToken) {
          console.warn("⚠️ No access token found in URL or localStorage");
          setIsLoading(false);
          return;
        }

        // Call the same API with token from localStorage to get user_id
        console.log("🔄 Fetching user ID using stored token...");

        const storedRefreshToken = localStorage.getItem("refreshToken");
        const storedEmail = localStorage.getItem("userEmail");

        const data = {
          redirect_url: `${window.location.origin}?accessToken=${finalAccessToken}${storedRefreshToken ? `&refreshToken=${storedRefreshToken}` : ''}${storedEmail ? `&email=${storedEmail}` : ''}`
        };
        console.log("data===>", data);

        const response = await axios.post(
          `${BASE_URL}/fetch_token`,
          data,
          {
            headers: {
              "Content-Type": "application/json",
              "Authorization": `Bearer ${finalAccessToken}`
            }
          }
        );

        if (response.data?.user_id) {
          console.log("✅ User ID fetched successfully:", response.data.user_id);
          const userIdValue = Number(response.data.user_id);
          setUserId(userIdValue);
          localStorage.setItem("userId", String(userIdValue));
          await fetchSpocAllowedPaths(finalAccessToken);
        } else {
          console.warn("⚠️ No user_id returned from API.");
        }
      } catch (error) {
        console.error("❌ Error fetching user ID from API:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchUserIdFromAPI();
  }, []);

  return { userId, isLoading };
}

export const getMenuItems = (userId = null) => {
  const authorise = localStorage.getItem("Authorise");
  const roles = {
    admin: authorise === "admin" ? true : false,
    staff: authorise === "staff" ? true : false,
    spoc: authorise === "spoc" ? true : false,
    manager: authorise === "manager" ? true : false,
    management: authorise === "management" ? true : false,
    educator: authorise === "educator" ? true : false,
    account_manager: authorise === "account_manager" ? true : false,
    talent: authorise === "talent" ? true : false,
    leaders: authorise === "leaders" ? true : false,
    dspoc: authorise === "dspoc" ? true : false,
    tpo: authorise === "tpo" ? true : false,
    trainer: authorise === "trainer" ? true : false,
    support: authorise === "support" ? true : false,
    accounts: authorise === "accounts" ? true : false,
    trainerspoc: authorise === "trainerspoc" ? true : false,
    desiner: authorise === "desiner" ? true : false,
    corporate: authorise === "corporate" ? true : false,
    business_development_manager: authorise === "business_development_manager" ? true : false,
  };

  return filterNavConfig(roles, userId);
};



export const MenuItems = () => {
  const storedUserId = localStorage.getItem("userId");
  console.log("📦 MenuItems - storedUserId:", storedUserId);

  let userId = null;
  if (storedUserId && storedUserId !== "null" && storedUserId !== "undefined") {
    userId = parseInt(storedUserId, 10);
    if (isNaN(userId)) {
      console.warn("⚠️ Invalid userId, setting to null");
      userId = null;
    }
  }

  console.log("🔧 MenuItems - parsed userId:", userId);
  return getMenuItems(userId);
};